import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "informations-content",
  class: "kn-flex kn-relative kn-height-full"
}
const _hoisted_2 = { class: "roles-absolute-scroll" }
const _hoisted_3 = { class: "p-fluid p-m-5" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "code",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = {
  for: "roleTypeID",
  class: "kn-material-input-label"
}
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { class: "p-field-checkbox" }
const _hoisted_18 = { for: "isPublic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Card, {
        style: _ctx.rolesManagementTabViewDescriptor.card.style
      }, {
        content: _withCtx(() => [
          _createVNode("form", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_InputText, {
                  id: "name",
                  class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.role.name.$invalid && _ctx.v$.role.name.$dirty
                                    }],
                  type: "text",
                  modelValue: _ctx.v$.role.name.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.role.name.$model = $event)),
                  modelModifiers: { trim: true },
                  maxLength: "100",
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.role.name.$touch())),
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFieldChange('name', $event.target.value))),
                  "data-test": "name-input"
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.role.name,
                additionalTranslateParams: {
                                    fieldName: _ctx.$t('common.name')
                                }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, [
                _createVNode(_component_InputText, {
                  id: "code",
                  class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.role.code.$invalid && _ctx.v$.role.code.$dirty
                                    }],
                  type: "text",
                  modelValue: _ctx.v$.role.code.$model,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.role.code.$model = $event)),
                  modelModifiers: { trim: true },
                  maxLength: "20",
                  onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.role.code.$touch())),
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFieldChange('code', $event.target.value))),
                  "data-test": "code-input"
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.rolesManagement.detail.code')), 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.role.code,
                additionalTranslateParams: {
                                    fieldName: _ctx.$t('managers.rolesManagement.detail.code')
                                }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_InputText, {
                  id: "description",
                  class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.role.description.$invalid && _ctx.v$.role.description.$dirty
                                    }],
                  type: "text",
                  modelValue: _ctx.v$.role.description.$model,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.role.description.$model = $event)),
                  modelModifiers: { trim: true },
                  maxLength: "150",
                  onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.role.description.$touch())),
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onFieldChange('description', $event.target.value))),
                  "data-test": "description-input"
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.description')), 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.role.description,
                additionalTranslateParams: {
                                    fieldName: _ctx.$t('common.description')
                                }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("span", _hoisted_14, [
                _createVNode(_component_Dropdown, {
                  id: "roleTypeID",
                  class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.role.roleTypeID.$invalid && _ctx.v$.role.roleTypeID.$dirty
                                    }],
                  options: _ctx.translatedRoleTypes,
                  optionLabel: "VALUE_CD",
                  optionValue: "VALUE_ID",
                  modelValue: _ctx.v$.role.roleTypeID.$model,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.role.roleTypeID.$model = $event)),
                  onBeforeShow: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.role.roleTypeID.$touch())),
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onRoleTypeChange('roleTypeID', 'roleTypeCD', $event)))
                }, null, 8, ["options", "modelValue", "class"]),
                _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('managers.rolesManagement.detail.roleTypeID')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.role.roleTypeID,
                additionalTranslateParams: {
                                    fieldName: _ctx.$t('managers.rolesManagement.detail.roleTypeID')
                                }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("span", _hoisted_17, [
                _createVNode(_component_Checkbox, {
                  id: "isPublic",
                  name: "isPublic",
                  modelValue: _ctx.role.isPublic,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.role.isPublic = $event)),
                  onChange: _ctx.onPublicChange,
                  binary: true,
                  "data-test": "is-public-checkbox"
                }, null, 8, ["modelValue", "onChange"]),
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('managers.rolesManagement.detail.isPublic')), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ])
  ]))
}